import { fillString } from '@local_modules/generic/string-template.js'
import { AutoAgGrid, generateString, setPageAsFullHeight } from '@local_modules/flokit'
import '@local_modules/flokit/styles.css'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 * @param {Object} params.browserAppEntity
 * @param {Object} params.accountingOrganisationId
 *
 * @returns
 */
export async function showAdminEntityJournalsDuplicates (params) {
  console.log('showAdminEntityJournalsDuplicates')

  const { containerElementId, browserAppUser, browserAppEntity, accountingOrganisationId } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    entityName: browserAppEntity.data.appEntity.name
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  // Set page title
  document.title = ['Entity duplicate journals'].join(' ')

  let apiUrl = '/api/data-review/entity-journals-duplicate/:accountingOrganisationId'
  apiUrl = fillString(apiUrl, { accountingOrganisationId })

  const autoAgGrid = new AutoAgGrid({
    containerSelector: '#entityGrid',
    sourceUrl: apiUrl
  })
  console.log('autoAgGrid', autoAgGrid)
  return autoAgGrid
}
